module.exports = {"220171001":"临河街道","220171002":"东方广场街道","220171003":"会展街道","220171004":"世纪街道","220171100":"兴隆山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220171.json
// module id = 699
// module chunks = 0